var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgSector({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M21.2788 3.49576C21.2336 3.16125 20.9705 2.89815 20.636 2.85295L14.4067 2.01116C14.1747 1.97981 13.9414 2.05856 13.7759 2.22407L2.32753 13.6725C2.03464 13.9654 2.03464 14.4402 2.32753 14.7331L9.3986 21.8042C9.6915 22.0971 10.1664 22.0971 10.4593 21.8042L21.9077 10.3558C22.0732 10.1903 22.1519 9.95699 22.1206 9.72503L21.2788 3.49576ZM3.91852 14.2028L14.5739 3.54739L19.8688 4.26291L20.5843 9.5578L9.92893 20.2132L3.91852 14.2028ZM15.5858 8.54594C16.1716 9.13173 17.1213 9.13173 17.7071 8.54594C18.2929 7.96015 18.2929 7.01041 17.7071 6.42462C17.1213 5.83883 16.1716 5.83883 15.5858 6.42462C15 7.01041 15 7.96015 15.5858 8.54594Z",
    fill: "black"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSector);
export default __webpack_public_path__ + "static/media/Sector.99e0a435595fef19d5385c0f07683df4.svg";
export { ForwardRef as ReactComponent };